(function() {
  angular.module('cfn').factory('FieldGroup', FieldGroup);

  FieldGroup.$inject = ['dataSource.factory'];

  function FieldGroup(dataSource) {
    return dataSource('fieldGroup').getRestService();
  }
})();
